import React, { FC } from 'react';
import { ReactComponent as ChowDeckIcon } from 'assets/icons/chowdeck-logo.svg';
import { ReactComponent as GlovoIcon } from 'assets/icons/glovo-logo.svg';
import { LiveTripOrderType } from 'models/live-trip.model';
import { OrderType } from 'models/order.model';
import { ENUM_ORDER_PROVIDER } from 'utils/enum';

const OrderTypeConfig: Record<ENUM_ORDER_PROVIDER, JSX.Element | null> = {
  [ENUM_ORDER_PROVIDER.glovo]: <GlovoIcon />,
  [ENUM_ORDER_PROVIDER.chowdeck]: <ChowDeckIcon />,
  [ENUM_ORDER_PROVIDER.foodcourt]: null
};

const OrderDeliveryProvider: FC<{ order: LiveTripOrderType | OrderType }> = ({ order }) => {
  if (!order) return null;

  return OrderTypeConfig[order.delivery];
};

export default OrderDeliveryProvider;
